export default "__VITE_ASSET__BcF1eyhY__"